import React, { useEffect, useState } from "react";
import { formateDateTime } from "../../utils";
import Avatar from "../../static/images/tia.png";
import { ChatEvents, MessageType, Roles } from "../../constants";
import { createImageFromInitials } from "../../AgentLogo";
import FileIcon from "../../static/images/icon-file.svg";
import DownloadIcon from "../../static/images/icon-download.svg";

import HealthPlanDetails from "./PlanDetails";

function JsonTemplate({
    message,
    displayAllOptions,
    GAEvent,
    showPlansComparison,
    regenDoc,
    selectOption,
    contactSupport,
    mainMenu,
    ViewPlanDetails
}) {

    const [viewMore, setViewMore] = useState(false)
    const content = JSON.parse(message.content);
    useEffect(() => {
        if (content.choices && content.choices.length > 4 && !message.selected) {
            setViewMore(true)
        }
    })
    // console.log(message.displayAllOptions)
    return (
        <>
            {content.type && content.type.toLowerCase() === MessageType.document ?
                <div className="grop_message">
                    <div onClick={() => regenDoc(content.document.docId)} className="download-policy-message message">
                        <div className="download-policy">
                            <img src={FileIcon} className="icon-file" alt="" /><p>Document</p><img src={DownloadIcon} className="icon-download" alt="" />
                        </div>

                    </div>
                </div>
                : null}

            {content.type && content.type.toLowerCase() === "selection" ?
                <>
                    {content.title ? (
                        <div class="grop_message">
                            <div
                                class="message"
                                dangerouslySetInnerHTML={{ __html: content.title }}
                            />
                        </div>
                    ) : null}
                    {message.selected ? null : (
                        <>
                            {content.choices.map((item1, index) => (
                                <>
                                    {message.displayAllOptions || index < 3 || !viewMore ?
                                        <div class="grop_message tabq">
                                            <div onClick={() => selectOption(item1, content.type, message.messageId)} class="question">
                                                {item1.display_value}
                                            </div>
                                        </div>
                                        : null}
                                </>
                            ))}
                            {viewMore && !message.displayAllOptions ?
                                <div class="grop_message tabq">
                                    <div onClick={() => displayAllOptions(message.messageId)} class="question">
                                        {"View More"}
                                    </div>
                                </div>
                                : null}
                        </>
                    )}
                </>
                : null}
            {content.type && content.type.toLowerCase() === "plan_multi_selection" ?
                <>
                    {content.title ? (
                        <div class="grop_message">
                            <div
                                class="message"
                                dangerouslySetInnerHTML={{ __html: content.title }}
                            />
                        </div>
                    ) : null}

                </>
                : null}
            {content.type && content.type.toLowerCase() === "plan_selection" ?
                <>
                    {content.title ? (
                        <div class="grop_message">
                            <div
                                class="message"
                                dangerouslySetInnerHTML={{ __html: content.title }}
                            />
                        </div>
                    ) : null}
                </>
                : null}
            {content.type && content.type === "plan_comparison" ?
                <>
                    <div className="grop_message tabq">
                        <div className="question " onClick={() => showPlansComparison(message.messageId)}>
                            View Comparison
                        </div>
                    </div>
                    {message && !message.selected ?
                        <>
                            <div className="grop_message tabq">
                                <div onClick={() => contactSupport(message.messageId)} className="question ">
                                    {"Support"}
                                </div>
                            </div>
                            <div className="grop_message tabq">
                                <div onClick={() => mainMenu(message.messageId)} className="question ">
                                    {"Main Menu"}
                                </div>
                            </div>
                        </>
                        : null}
                </>
                : null}
            {content.type && content.type === "list_plans" ?
                <HealthPlanDetails GAEvent={GAEvent} message={message} ViewPlanDetails={ViewPlanDetails} contactSupport={contactSupport} mainMenu={mainMenu} content={content} ></HealthPlanDetails>
                : null}
            {content.type && content.type === "CustomerEngage" ?
                <>
                    {message.selected ? null : content.choices.map((item1, index) => (
                        <div class="grop_message tabq" key={item1.key}>
                            <div onClick={() => selectOption(item1, "selection", message.messageId)} className="question " >
                                {item1.display_value}
                            </div>
                        </div>
                    ))}
                </>
                : null}
        </>
    );
}

export default function TravelAgentMessage({
    messages,
    agentName,
    displayAllOptions,
    GAEvent,
    showPlansComparison,
    regenDoc,
    selectOption,
    contactSupport,
    mainMenu,
    AgentMsg,
    ViewPlanDetails
}) {
    return (
        <li class="you">
            {messages.map((item) => (
                <>
                    {item.type.toLowerCase() === "json" ? (
                        <JsonTemplate
                            message={item}
                            displayAllOptions={displayAllOptions}
                            GAEvent={GAEvent}
                            showPlansComparison={showPlansComparison}
                            regenDoc={regenDoc}
                            selectOption={selectOption}
                            contactSupport={contactSupport}
                            mainMenu={mainMenu}
                            AgentMsg={AgentMsg}
                            ViewPlanDetails={ViewPlanDetails}
                        ></JsonTemplate>
                    ) : (
                        <>
                            {item.type === MessageType.html ? (
                                <div class="grop_message">
                                    <div
                                        class="message"
                                        dangerouslySetInnerHTML={{
                                            __html: item.content,
                                        }}
                                    >
                                        {" "}
                                    </div>
                                </div>
                            ) : (
                                <div class="grop_message">
                                    <div class="message">{item.content} </div>
                                </div>
                            )}
                        </>
                    )}
                </>
            ))}
            <div class="entete">
                <h3>{formateDateTime(messages[messages.length - 1].sentAt)}</h3>
            </div>
            <div class="usericon">
                {AgentMsg ? (
                    <img
                        id="preview"
                        src={
                            createImageFromInitials(500, agentName, "blue") // getRandomColor()
                        }
                        alt="profile-pic"
                    />
                ) : (
                    <img src={Avatar} alt=""></img>
                )}
            </div>
        </li>
    );
}
